import { z } from 'zod';
export const productFeedbackKinds = ['feature_request', 'feedback', 'review'];
export const productFeedbackStatuses = ['new', 'reviewing', 'planned', 'in_progress', 'shipped', 'closed'];
export const productFeedbackSchema = z.strictObject({
    submissionId: z.uuid(),
    kind: z.enum(productFeedbackKinds),
    subject: z.string().trim().min(3).max(160),
    message: z.string().trim().min(10).max(5000),
    rating: z.number().int().min(1).max(5).nullable().default(null),
    contactEmail: z.email().max(254).nullable().default(null),
    contactPhone: z.string().trim().regex(/^\+?[0-9 ()-]{7,30}$/).nullable().default(null),
}).refine((value) => value.kind === 'review' ? value.rating !== null : value.rating === null, {
    message: 'A rating is required only for an app review.', path: ['rating'],
});
export const releaseCopySchema = z.strictObject({
    title: z.string().trim().min(4).max(100),
    summary: z.string().trim().min(10).max(240),
    highlights: z.array(z.string().trim().min(3).max(180)).min(3).max(5),
    ctaLabel: z.string().trim().min(2).max(40),
});
// Same-origin product routes only; no redirects, credentials, or executable URLs.
export const releaseDestinationSchema = z.string().max(240)
    .regex(/^\/(?:dashboard(?:\/[a-z0-9-]+)*|changelog)(?:#[a-z0-9-]+)?$/);
export const releaseDraftSchema = z.strictObject({
    id: z.string().regex(/^[a-z0-9][a-z0-9-]{2,79}$/),
    version: z.string().regex(/^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)$/),
    notification: z.enum(['silent', 'popup']),
    destination: releaseDestinationSchema,
    content: z.strictObject({ en: releaseCopySchema, ar: releaseCopySchema }),
});
//# sourceMappingURL=product-updates.js.map